/* PabDer — PDP variant picker, variations flyout, size guide, carousels, bag size compare */
(function(){
  function init(){
    var data=document.getElementById('pdpVariantData');
    var form=document.getElementById('pdpForm');
    if(data&&form){
      var variants=JSON.parse(data.textContent);
      var idSel=document.getElementById('pdpVariantId');
      var priceEl=document.getElementById('pdpPrice');
      var addBtn=document.getElementById('pdpAdd');
      var colorName=document.getElementById('pdpColorName');
      var codeEl=document.getElementById('pdpCode');
      var note=document.getElementById('pdpNote');
      var groups=[].slice.call(form.querySelectorAll('[data-option-index]'));
      var selected=[];

      function swapImage(src){
        if(!src)return;
        var gi=document.querySelector('.gallery .shot img');
        if(gi){gi.removeAttribute('srcset');gi.removeAttribute('sizes');gi.src=src;}
      }
      function selectSwatch(g,b){
        g.querySelectorAll('button').forEach(function(x){x.classList.remove('active');});
        b.classList.add('active');
        var idx=parseInt(g.dataset.optionIndex,10)-1;
        selected[idx]=b.dataset.value;
        if(b.classList.contains('swatch')){
          if(colorName)colorName.textContent=b.dataset.value;
          swapImage(b.dataset.img);
        }
        update();
      }
      groups.forEach(function(g){
        var idx=parseInt(g.dataset.optionIndex,10)-1;
        var act=g.querySelector('.active');
        selected[idx]=act?act.dataset.value:null;
        g.querySelectorAll('button').forEach(function(b){
          b.addEventListener('click',function(){
            if(b.classList.contains('oos'))return;
            selectSwatch(g,b);
          });
        });
      });
      function renderPrice(use){
        if(!priceEl) return;
        var foreign = window.PDCurrency && window.PDCurrency.isForeign();
        var mainTxt = (foreign && use.price_cents!=null) ? window.PDCurrency.formatUsd(use.price_cents/100) : use.price;
        var wasHtml = '';
        if(use.compare){
          var wasTxt = (foreign && use.compare_cents!=null) ? window.PDCurrency.formatUsd(use.compare_cents/100) : use.compare;
          wasHtml = ' <span class="was">'+wasTxt+'</span>';
        }
        priceEl.innerHTML = mainTxt + wasHtml;
        var estEl = document.getElementById('pdpUsdEst');
        if(estEl){
          if(foreign && use.price_cents!=null){
            estEl.textContent = window.PDCurrency.formatPhpNote(use.price_cents/100);
            estEl.hidden = false;
          } else {
            estEl.hidden = true;
          }
        }
      }
      // Re-check each size button's availability against the variant table, given
      // whichever OTHER options (colour, etc.) are currently selected. The server-
      // rendered "oos" class only knows whether a size is sold out across every
      // colour — it doesn't know per-colour stock, so a size that's in stock in one
      // colour but not the currently-picked one looked clickable/available even
      // though selecting it produced a sold-out combo (dark "active" button with no
      // strike-through, since the oos styling was never applied). Recomputing here,
      // every time a swatch changes, keeps the size row honest for whichever colour
      // is currently selected.
      function refreshSizeAvailability(){
        groups.forEach(function(g){
          if(!g.classList.contains('sizes'))return;
          var idx=parseInt(g.dataset.optionIndex,10)-1;
          g.querySelectorAll('button').forEach(function(b){
            var testSel=selected.slice();
            testSel[idx]=b.dataset.value;
            var match=variants.find(function(vv){
              return vv.options.every(function(o,i){return testSel[i]==null||testSel[i]===o;});
            });
            var avail=!!(match&&match.available);
            b.classList.toggle('oos',!avail);
            b.disabled=!avail;
          });
        });
      }
      function update(){
        var v=variants.find(function(vv){return vv.options.every(function(o,i){return selected[i]==null||selected[i]===o;});});
        var exact=variants.find(function(vv){return vv.options.every(function(o,i){return selected[i]===o;});});
        var use=exact||v;
        if(use){
          if(idSel)idSel.value=use.id;
          renderPrice(use);
          if(addBtn){addBtn.disabled=!use.available;addBtn.textContent=use.available?'Add to Shopping Bag':'Sold out';}
          if(codeEl){
            if(use.sku){var skuBase=use.sku.split('-')[0];codeEl.textContent='Code: '+skuBase;codeEl.style.display='';}
            else{codeEl.style.display='none';}
          }
          if(note)note.classList.remove('show');
        }
        refreshSizeAvailability();
      }

      // Re-render the price once currency detection resolves (handles the case where
      // a product has no swatches to click, so update() would otherwise never re-fire
      // and non-PH visitors would keep seeing the server-rendered PHP price forever).
      if(window.PDCurrency){
        window.PDCurrency.onReady(function(){ update(); });
      } else {
        update();
      }

      // variations flyout
      var fly=document.getElementById('varFlyout'),scr=document.getElementById('varScrim'),viewC=document.getElementById('viewColors');
      function openFly(){if(fly){fly.classList.add('open');scr.classList.add('show');fly.setAttribute('aria-hidden','false');}}
      function closeFly(){if(fly){fly.classList.remove('open');scr.classList.remove('show');fly.setAttribute('aria-hidden','true');}}
      if(viewC)viewC.addEventListener('click',function(e){e.preventDefault();openFly();});
      var vfClose=document.getElementById('vfClose');
      if(vfClose)vfClose.addEventListener('click',closeFly);
      if(scr)scr.addEventListener('click',closeFly);
      document.querySelectorAll('.vf-item').forEach(function(it){
        it.addEventListener('click',function(){
          var sw=form.querySelector('.swatch[data-value="'+it.dataset.value.replace(/"/g,'\\"')+'"]');
          if(sw){var g=sw.closest('[data-option-index]');selectSwatch(g,sw);}
          document.querySelectorAll('.vf-item').forEach(function(x){x.classList.remove('cur');});
          it.classList.add('cur');
          closeFly();
        });
      });

      form.addEventListener('submit',function(e){
        var complete=selected.length===groups.length&&selected.every(Boolean);
        if((addBtn&&addBtn.disabled)||!complete){e.preventDefault();if(note)note.classList.add('show');}
      });

      var express=document.getElementById('pdpExpress');
      if(express)express.addEventListener('click',function(){
        var complete=selected.length===groups.length&&selected.every(Boolean);
        if(!complete||(addBtn&&addBtn.disabled)){if(note)note.classList.add('show');return;}
        express.textContent='…';
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:idSel.value,quantity:1})})
          .then(function(){window.location.href='/checkout';})
          .catch(function(){express.textContent='Express Checkout';});
      });
    }

    // Size guide flyout
    var sizeFly=document.getElementById('sizeFlyout'),sizeScr=document.getElementById('sizeScrim'),sizeTrigger=document.getElementById('sizeGuideTrigger'),sizeClose=document.getElementById('sizeClose');
    function openSizeFly(){if(sizeFly){sizeFly.classList.add('open');sizeScr.classList.add('show');sizeFly.setAttribute('aria-hidden','false');}}
    function closeSizeFly(){if(sizeFly){sizeFly.classList.remove('open');sizeScr.classList.remove('show');sizeFly.setAttribute('aria-hidden','true');}}
    if(sizeTrigger&&!sizeTrigger.dataset.bound){
      sizeTrigger.dataset.bound='1';
      sizeTrigger.addEventListener('click',function(e){e.preventDefault();openSizeFly();});
    }
    if(sizeClose&&!sizeClose.dataset.bound){sizeClose.dataset.bound='1';sizeClose.addEventListener('click',closeSizeFly);}
    if(sizeScr&&!sizeScr.dataset.bound){sizeScr.dataset.bound='1';sizeScr.addEventListener('click',closeSizeFly);}
    document.querySelectorAll('.sg-tab').forEach(function(tab){
      if(tab.dataset.bound)return;
      tab.dataset.bound='1';
      tab.addEventListener('click',function(){
        var g=tab.getAttribute('data-sg');
        document.querySelectorAll('.sg-tab').forEach(function(t){t.classList.toggle('on',t===tab);t.setAttribute('aria-selected',t===tab?'true':'false');});
        document.querySelectorAll('.sg-panel').forEach(function(p){p.classList.toggle('on',p.getAttribute('data-sg-panel')===g);});
      });
    });

    // Bag-to-body size comparison widget
    document.querySelectorAll('.bagfit').forEach(function(box){
      if(box.dataset.bound)return;
      box.dataset.bound='1';
      var scale=parseFloat(box.dataset.scale||'1.6');
      var figure=box.querySelector('[data-bagfit-figure]');
      box.querySelectorAll('.bf-h').forEach(function(btn){
        btn.addEventListener('click',function(){
          box.querySelectorAll('.bf-h').forEach(function(b){b.classList.toggle('on',b===btn);});
          var h=parseFloat(btn.dataset.h);
          if(figure)figure.style.height=(h*scale)+'px';
        });
      });
    });

    document.querySelectorAll('.car-nav button').forEach(function(b){
      if(b.dataset.carBound)return;
      b.dataset.carBound='1';
      b.addEventListener('click',function(){
        var el=document.getElementById(b.dataset.car);
        if(el)el.scrollBy({left:parseInt(b.dataset.dir,10)*el.clientWidth*0.6,behavior:'smooth'});
      });
    });

    // Frequently bought together (native Shopify complementary recommendations)
    var fbtRoot=document.getElementById('fbtBlock');
    if(fbtRoot&&!fbtRoot.dataset.bound){
      fbtRoot.dataset.bound='1';
      var fbtPid=fbtRoot.dataset.productId;
      fetch('/recommendations/products.json?product_id='+fbtPid+'&intent=complementary&limit=3')
        .then(function(r){return r.json();})
        .then(function(data){
          var products=(data&&data.products)||[];
          products=products.filter(function(p){return p.variants&&p.variants[0]&&p.variants[0].id;});
          if(!products.length)return;
          var foreign = window.PDCurrency && window.PDCurrency.isForeign();
          var html='<h4>Frequently bought together</h4><div class="fbt-list">';
          products.forEach(function(p){
            var v=p.variants[0];
            var img=p.featured_image||(p.images&&p.images[0])||'';
            var price='';
            if(typeof p.price==='number'){
              price = (foreign && window.PDCurrency) ? window.PDCurrency.formatUsd(p.price/100) : '₱'+(p.price/100).toFixed(2);
            }
            html+='<label class="fbt-item"><input type="checkbox" class="fbt-check" value="'+v.id+'" checked>'+
              '<span class="fbt-thumb">'+(img?'<img src="'+img+'" alt="'+String(p.title).replace(/"/g,'&quot;')+'">':'')+'</span>'+
              '<span class="fbt-name">'+p.title+'</span><span class="fbt-price">'+price+'</span></label>';
          });
          html+='</div><button type="button" class="btn btn-outline btn-block" id="fbtAdd">Add selected to bag</button>';
          fbtRoot.innerHTML=html;
          fbtRoot.hidden=false;
          var fbtBtn=fbtRoot.querySelector('#fbtAdd');
          fbtBtn.addEventListener('click',function(){
            var items=Array.prototype.slice.call(fbtRoot.querySelectorAll('.fbt-check:checked')).map(function(c){
              return {id:parseInt(c.value,10),quantity:1};
            });
            if(!items.length)return;
            fbtBtn.disabled=true;fbtBtn.textContent='Adding…';
            fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
              .then(function(){window.location.reload();})
              .catch(function(){fbtBtn.disabled=false;fbtBtn.textContent='Add selected to bag';});
          });
        })
        .catch(function(){});
    }

    // Drag-to-scroll with the mouse for the "Alternative looks" / "You may also like" rails.
    // Only start actually moving scrollLeft once the pointer has moved past a small
    // threshold — otherwise the sub-pixel jitter of a normal click nudges the rail's
    // scroll position by the time mouseup fires, shifting the card out from under the
    // pointer and silently swallowing the click (product link never navigates).
    document.querySelectorAll('.car').forEach(function(car){
      if(car.dataset.dragBound)return;
      car.dataset.dragBound='1';
      car.querySelectorAll('img').forEach(function(img){img.setAttribute('draggable','false');});
      var isDown=false,startX,scrollLeft,moved=false;
      car.addEventListener('mousedown',function(e){
        isDown=true;moved=false;
        startX=e.pageX-car.offsetLeft;scrollLeft=car.scrollLeft;
      });
      ['mouseleave','mouseup'].forEach(function(evt){
        car.addEventListener(evt,function(){isDown=false;car.classList.remove('dragging');});
      });
      car.addEventListener('mousemove',function(e){
        if(!isDown)return;
        var x=e.pageX-car.offsetLeft;
        var walk=(x-startX)*1.2;
        if(!moved&&Math.abs(walk)>5){
          moved=true;
          car.classList.add('dragging');
        }
        if(moved){
          e.preventDefault();
          car.scrollLeft=scrollLeft-walk;
        }
      });
      car.addEventListener('click',function(e){
        if(moved){e.preventDefault();e.stopPropagation();moved=false;}
      },true);
    });
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();